export default "__VITE_ASSET__BtfAJYsb__"